import * as PIXI from "pixi.js";
import gsap from "gsap"
import { gameAssets } from "./gameUI"
import { playBigAudio, playEnkCAudio, playMegaAudio, playMegaWin, playMiniAudio, playUltraAudio, playUltraWin } from "./soundManager"
import { COMMENDATION, GAME_STATES } from "./constants"
import { incrementValue, tweenFade, tweenFadeAppear, tweenScaleAppear, tweenScaleDisAppear } from "./utility"
import { commendationType, setCommendationType } from "./animations"
import { playCoinAnimation, stopCoinAnimation } from "./popups/coins"
import { resetGameSettings, showJackpots } from "./gameLogic"
import { gameData, networkData } from "./data"
import { controlJackpotWinSpine } from "./gameLogic"

const animationArray = [
    'jackpot/fx_in',  //0
    'jackpot/fx_loop',
    'jackpot/fx_out',
    'big_win_in',  // 3
    'big_win_loop',
    'big_win_out',
    'mega_win_in',  // 6
    'mega_win_loop',
    'mega_win_out',
    'ultra_win_in',  // 9
    'ultra_win_loop',
    'ultra_win_out',
    'jackpot/minor_in',  // 12 
    'jackpot/minor_loop',
    'jackpot/minor_out',
    'jackpot/major_in',  // 15
    'jackpot/major_loop',
    'jackpot/major_out',
    "jackpot/grand_in", // 18
    "jackpot/grand_loop",
    "jackpot/grand_out",
]

const newWinAnimations = ["version 1/bigwin", "version 1/bigwin_and_megawin", "version 1/bigwin_and_megawin_and_ultrawin"];

let jackpotPlayed = false;
let duration = 0;
let trackAnimation = null;
let flag = true;


export let delayedCalls = []
let delayedCall = null, commendationAmount = 0
// let delayedCallNormalOne, delayedCallNormalTwo, delayedCallNormalThree, delayedCallNormalFour,
// delayedCallBigOne, delayedCallBigTwo, delayedCallBigThree, delayedCallBigFour,
// delayedCallMegaOne, delayedCallMegaTwo, delayedCallMegaThree, delayedCallMegaFour,
// delayedCallUltraOne, delayedCallUltraTwo, delayedCallUltraThree, delayedCallUltraFour,
// delayedCallMinorJackpotOne, delayedCallMinorJackpotTwo, delayedCallMinorJackpotThree, delayedCallMinorJackpotFour,
// delayedCallMajorJackpotOne, delayedCallMajorJackpotTwo, delayedCallMajorJackpotThree, delayedCallMajorJackpotFour


const setUpAnimation = (spineObject, animationIndex, isLoop) => {
    const animation = animationArray[animationIndex]
    

    if (animation) {
        // const spineObject = animationIndex < 3 ? gameAssets.amazing : gameAssets.commendation
        
        spineObject.visible = true
        spineObject.state.setAnimation(0, animation, isLoop)
        // spineObject.resize(settings.currentWidth, settings.currentHeight)  
    } 
    else {
        // console.warn(`Animation at index ${animationIndex} not found.`)
    }
}


const setupNewWinAnimation = (spineObject, animationIndex, isLoop, backgroundBlur, textObject) => {
    const animation = newWinAnimations[animationIndex];
  
    if (animation) {
      spineObject.visible = true;
  
      trackAnimation = spineObject.state.setAnimation(0, animation, isLoop);
  
      if (trackAnimation && trackAnimation.animation) {
        duration = trackAnimation.animation.duration;
        console.log(`Animation duration: ${duration} seconds`);
      }
  
      trackAnimation.listener = {
        complete: () => {
        stopCoinAnimation();
        tweenScaleDisAppear(gameAssets.commendationValueBitmap, false);
        setCommendationType(COMMENDATION.NONE)
        spineObject.interactive = false;
        spineObject.visible = false;

        playBigAudio(false)
        playMegaWin(false)
        playUltraWin(false)

        duration = 0;
        flag = true;
  
        stopDelayedCalls()
  
        if(networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin){
            showJackpots()   
        } else {
            gameAssets.dimmer.visible = false;
            gameAssets.dimmer.interactive = false;   
            playEnkCAudio(true)
            resetGameSettings()
         }
        }
      };
    } else {
    //   console.warn(`Animation at index ${animationIndex} not found.`);
    }
  };


  const stopDelayedCalls = () => {
    delayedCalls.forEach((c) => {
      if (c) c.kill();
    });
    delayedCall = null;
    delayedCalls = [];
  }

  const stopNumberCounter = (amt) => {
    gameData.showWinAmount = false;
  
    stopDelayedCalls()
    gameAssets.commendationValueBitmap.visible = true
    gsap.killTweensOf(gameAssets.commendationValueBitmap);
    gameAssets.commendationValueBitmap.scale.set(1);
    gameAssets.commendationValueBitmap.text = amt.toFixed(2);
  }

export const normalWin = (amt = '0') => {
    gameData.winOver = true;
        
    commendationAmount = amt
    playMiniAudio(true)
    playCoinAnimation(0)
    tweenFade(gameAssets.dimmer, true)
        gameAssets.amazingWinValueBitmap.text = 0
        gameAssets.amazingWinValueBitmap.visible = true
        tweenFadeAppear(gameAssets.amazingBitmap, true, 0.2)
        tweenScaleAppear(gameAssets.amazingWinValueBitmap, 0.5, () => {
            increaseNumCount(gameAssets.amazingWinValueBitmap, amt, 5)
        })
    
    setUpAnimation(gameAssets.amazing, 0, false)
        setUpAnimation(gameAssets.amazing, 1, true)
    
    gameAssets.skipBtn.visible = true;
    gameAssets.skipBtn.alpha = 1
    gameAssets.skipBtn.interactive = true;
    gameAssets.skipBtn.cursor = 'pointer'
    gameAssets.skipBtn.once("pointertap", closeAmazingWin);

    delayedCall = gsap.delayedCall(9, closeAmazingWin);
    delayedCalls.push(delayedCall)
}

function closeAmazingWin() {

    if (delayedCall) {
        delayedCall.kill();
    }

        setUpAnimation(gameAssets.amazing, 2, false);

        tweenFadeAppear(gameAssets.amazingBitmap, false);
        tweenScaleDisAppear(gameAssets.amazingWinValueBitmap, false);

        stopCoinAnimation();

        gameAssets.amazingBitmap.visible = false;

        gameAssets.skipBtn.visible = false;
        gameAssets.skipBtn.interactive = false;
        gameAssets.skipBtn.off("pointertap", closeAmazingWin);

        if (commendationType === COMMENDATION.NORMAL) {
            playEnkCAudio(true);
            if (
                networkData.jackpotMinorWin ||
                networkData.jackpotMajorWin ||
                networkData.jackpotGrandWin
            ) {
                showJackpots();

            } else {

                setCommendationType(COMMENDATION.NONE);

                tweenFade(gameAssets.dimmer, false);

                gameAssets.skipBtn.alpha = 0
                gameAssets.skipBtn.visible = false

                commendationAmount = 0;

                delayedCall = null;
                delayedCalls = [];

                resetGameSettings(0.5);
            }
        }
}
export const bigWin = (amt = '0') => {
    commendationAmount = amt
    gameData.showWinAmount = true;


    playBigAudio(true)
    playCoinAnimation(0)
    tweenFade(gameAssets.dimmer, true)
    gameAssets.commendation.interactive = true
    gameAssets.dimmer.visible = true;

    setupNewWinAnimation(gameAssets.commendation, 0, false)

    delayedCall = gsap.delayedCall(1.5, () => {
        gameAssets.commendationValueBitmap.text = 0
        tweenScaleAppear(gameAssets.commendationValueBitmap, 0.5, () => {
            delayedCall = gsap.delayedCall(0.2, ()=>{
                if(!gameData.showWinAmount) return;
                increaseNumCount(gameAssets.commendationValueBitmap, amt, duration)
            })
            delayedCalls.push(delayedCall)
        })
    }) 
    delayedCalls.push(delayedCall);
    
    // delayedCall = gsap.delayedCall(7.5, ()=>{
    //     tweenScaleDisAppear(gameAssets.commendationValueBitmap, false)
    //     stopCoinAnimation()
    //     if(commendationType === COMMENDATION.BIG){
    //         playEnkDAudio(true)
    //         gameAssets.commendation.interactive = false
    //         if(networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin){
    //           showJackpots()
    //         } else {
    //           setCommendationType(COMMENDATION.NONE)
    //           tweenFade(gameAssets.dimmer, false)
    //           gameAssets.dimmer.visible = false;
    //           commendationAmount = 0
    //           delayedCall = null
    //           delayedCalls = []
    //           resetGameSettings(0.5)
    //         }
    //     }
    // })
    // delayedCalls.push(delayedCall)
// }
}

export const megaWin = (amt = '0') => {
    
        playMegaWin(true);
        playCoinAnimation(1)
        tweenFade(gameAssets.dimmer, true);
        gameAssets.commendation.interactive = true
        gameAssets.dimmer.visible = true;
        gameData.showWinAmount = true;

        delayedCall = gsap.delayedCall(1.5, () => {
            gameAssets.commendationValueBitmap.text = 0
            tweenScaleAppear(gameAssets.commendationValueBitmap, 0.5, () => {
                delayedCall = gsap.delayedCall(0.2, ()=>{
                    if(!gameData.showWinAmount) return;
                    increaseNumCount(gameAssets.commendationValueBitmap, amt, duration)
                })
                delayedCalls.push(delayedCall)
            })
        }) 
        delayedCalls.push(delayedCall)
        
       setupNewWinAnimation(gameAssets.commendation, 1, false)
        
}

export const ultraWin = (amt = '0') => {
    
        playUltraWin(true)
        playCoinAnimation(2)
        tweenFade(gameAssets.dimmer, true);
        gameAssets.commendation.interactive = true
        gameAssets.dimmer.visible = true;
        gameData.showWinAmount = true;

        delayedCall = gsap.delayedCall(1.5, () => {
            gameAssets.commendationValueBitmap.text = 0
            tweenScaleAppear(gameAssets.commendationValueBitmap, 0.5, () => {
                delayedCall = gsap.delayedCall(0.2, ()=>{
                    if(!gameData.showWinAmount) return;
                    increaseNumCount(gameAssets.commendationValueBitmap, amt, duration)
                })
                delayedCalls.push(delayedCall)
            })
        }) 
        delayedCalls.push(delayedCall)
        
       setupNewWinAnimation(gameAssets.commendation, 2, false)

        // delayedCall = gsap.delayedCall(9, ()=>{
        //     setUpAnimation(gameAssets.commendation, 11, false)
        //     tweenScaleDisAppear(gameAssets.commendationValueBitmap, false)
        //     stopCoinAnimation()
        //     if(commendationType === COMMENDATION.ULTRA){
        //         playEnkDAudio(true)
        //         gameAssets.commendation.interactive = false
        //         if(networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin){
        //             showJackpots()
        //         } else {
        //             setCommendationType(COMMENDATION.NONE)
        //             tweenFade(gameAssets.dimmer, false)
        //             commendationAmount = 0
        //             delayedCall = null
        //             delayedCalls = []
        //             gameAssets.dimmer.visible = false;
        //             resetGameSettings(0.5)
        //           }
        //     }
        // })
        // delayedCalls.push(delayedCall)
}

export const minorJackpot = (amt = '0') => {
    networkData.jackpotMinorWin = false
    gameData.showAmount = true;
    commendationAmount = amt
    playMiniAudio(true)
    playCoinAnimation(0)
    tweenFade(gameAssets.dimmer, true)
    gameAssets.amazing.interactive = true;
    
    delayedCall = gsap.delayedCall(1.5, () => {
        gameAssets.amazingWinValueBitmap.visible = true
        gameAssets.amazingWinValueBitmap.text = 0
        tweenScaleAppear(gameAssets.amazingWinValueBitmap, 0.5, () => 
            delayedCall = gsap.delayedCall(0.2, ()=>{
                if(!gameData.showAmount) return;
                increaseNumCount(gameAssets.amazingWinValueBitmap, amt)
            } 
            )
        )
    }) 
    delayedCalls.push(delayedCall)
    
    setUpAnimation(gameAssets.amazing, 12, false)
    delayedCall = gsap.delayedCall(2, ()=>{
        setUpAnimation(gameAssets.amazing, 13, true)
    })
    delayedCalls.push(delayedCall)

    delayedCall = gsap.delayedCall(9, ()=>{
        setUpAnimation(gameAssets.amazing, 14, false)

        if(networkData.jackpotMajorWin){
          controlJackpotWinSpine(0, false);
          controlJackpotWinSpine(1, true);
          networkData.jackpotMinorWinAmount = 0;
          majorJackpot(networkData.jackpotMajorWinAmount);
          setCommendationType(COMMENDATION.MAJOR)

        } else if(networkData.jackpotGrandWin){
            controlJackpotWinSpine(1, false);
            controlJackpotWinSpine(2, true);
            networkData.jackpotMajorWinAmount = 0;
            networkData.jackpotMinorWinAmount = 0;
            grandJackpot(networkData.jackpotGrandWinAmount);
            setCommendationType(COMMENDATION.GRAND)
        }
      
        tweenScaleDisAppear(gameAssets.amazingWinValueBitmap, false)
        if(commendationType === COMMENDATION.MINOR) {
            stopCoinAnimation()
            playEnkCAudio(true)
            gameAssets.amazing.interactive = false;
            setCommendationType(COMMENDATION.NONE)
            tweenFade(gameAssets.dimmer, false)
            gameAssets.dimmer.visible = false
            commendationAmount = 0
            delayedCall = null
            delayedCalls = []
              resetGameSettings(0.5)
        }
    })
    delayedCalls.push(delayedCall)

}

export const majorJackpot = (amt = 1000) => {
    networkData.jackpotMajorWin = false
    gameData.showAmount = true;
    commendationAmount = amt
    playMiniAudio(false)
    playMegaAudio(true)
    playCoinAnimation(1)
    tweenFade(gameAssets.dimmer, true);
    gameAssets.amazing.interactive = true;
    
    delayedCall = gsap.delayedCall(1.5, () => {
        gameAssets.amazingWinValueBitmap.text = 0
        gameAssets.amazingWinValueBitmap.visible = true
        tweenScaleAppear(gameAssets.amazingWinValueBitmap, 0.5, () => 
            delayedCall = gsap.delayedCall(0.2, ()=>
                {
                    if(!gameData.showAmount) return;
                    increaseNumCount(gameAssets.amazingWinValueBitmap, amt)
                } 
            )
        )
    }) 
    delayedCalls.push(delayedCall)

    
    setUpAnimation(gameAssets.amazing, 15, false)
    delayedCall = gsap.delayedCall(2, ()=>{
        setUpAnimation(gameAssets.amazing, 16, true)
    })
    delayedCalls.push(delayedCall)

    delayedCall = gsap.delayedCall(9, ()=>{
        setUpAnimation(gameAssets.amazing, 17, false)
        
        if(networkData.jackpotGrandWin){
          controlJackpotWinSpine(1, false);
          controlJackpotWinSpine(2, true);
          networkData.jackpotMinorWinAmount = 0;
          networkData.jackpotMajorWinAmount = 0;
          grandJackpot(networkData.jackpotGrandWinAmount);
          setCommendationType(COMMENDATION.GRAND)
        }

        tweenScaleDisAppear(gameAssets.amazingWinValueBitmap, false)
        if(commendationType === COMMENDATION.MAJOR) {
            stopCoinAnimation()
            playEnkCAudio(true)
            gameAssets.amazing.interactive = false;
            setCommendationType(COMMENDATION.NONE)
            tweenFade(gameAssets.dimmer, false)
            gameAssets.dimmer.visible = false
            commendationAmount = 0
            delayedCall = null
            delayedCalls = []
              resetGameSettings(0.5)
        }
    })
    delayedCalls.push(delayedCall)

}

export const grandJackpot = (amt) => {
    networkData.jackpotGrandWin = false
    gameData.showAmount = true;
    commendationAmount = amt
    playMiniAudio(false)
    playMegaAudio(false);
    playMegaAudio(true)
    playCoinAnimation(2);
    tweenFade(gameAssets.dimmer, true);
    gameAssets.amazing.interactive = true;

    delayedCall = gsap.delayedCall(1.5, () => {
        gameAssets.amazingWinValueBitmap.text = 0
        gameAssets.amazingWinValueBitmap.visible = true
        tweenScaleAppear(gameAssets.amazingWinValueBitmap, 0.5, () => 
            delayedCall = gsap.delayedCall(0.2, ()=>{
                if(!gameData.showAmount) return;
                increaseNumCount(gameAssets.amazingWinValueBitmap, amt)
            } 
            )
        )
    }) 
    delayedCalls.push(delayedCall)

    setUpAnimation(gameAssets.amazing, 18, false)
    delayedCall = gsap.delayedCall(2, ()=>{
        setUpAnimation(gameAssets.amazing, 19, true)
    })
    delayedCalls.push(delayedCall);

    delayedCall = gsap.delayedCall(9, ()=>{
        setUpAnimation(gameAssets.amazing, 20, false)
        tweenScaleDisAppear(gameAssets.amazingWinValueBitmap, false)
        stopCoinAnimation()
        if(commendationType === COMMENDATION.GRAND) {            
            playEnkCAudio(true)
            gameAssets.amazing.interactive = false;
            setCommendationType(COMMENDATION.NONE)
            tweenFade(gameAssets.dimmer, false)
            gameAssets.dimmer.visible = false;
            commendationAmount = 0
            delayedCall = null
            delayedCalls = []
              resetGameSettings(0.5)
        }
    })
    delayedCalls.push(delayedCall)

}

export const controlWinFlow = () =>{
    if (gameData.showWinAmount) {
      stopNumberCounter(networkData.winAmount);
    }  else if (flag) {
      trackAnimation.trackTime = duration - 2;
      flag = false;
    }
}

export const clickToStopCommendation = () => {    
    // gameData.gameState = GAME_STATES.IDLE
    delayedCalls.forEach(c => {
        if(c) c.kill()
    })

    if(gameData.winOver){
        stopCoinAnimation()
        gameData.winOver = false;
        
       
        gameAssets.amazing.visible = false;
        gameAssets.amazingBitmap.visible = false;
        gameAssets.amazingWinValueBitmap.visible = false;
        tweenScaleDisAppear(gameAssets.commendationValueBitmap, false);
        setCommendationType(COMMENDATION.NONE)
        playMiniAudio(false)
        playBigAudio(false)
        playMegaAudio(false)
        playUltraAudio(false)
        if(networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin){
          showJackpots()
        } else {
          playEnkCAudio(true)
          tweenFade(gameAssets.dimmer, false)
          resetGameSettings(1)
        }

    } else if(gameData.showAmount){
        gameData.showAmount = false;
        gameAssets.amazingWinValueBitmap.visible = true
        gsap.killTweensOf(gameAssets.amazingWinValueBitmap);
        gameAssets.amazingWinValueBitmap.scale.set(1);

        if (networkData.jackpotMinorWinAmount !== undefined && networkData.jackpotMinorWinAmount) {
            const amount = parseFloat(networkData.jackpotMinorWinAmount);
            if (!isNaN(amount)) {
                gameAssets.amazingWinValueBitmap.text = amount.toFixed(2);
                setUpAnimation(gameAssets.amazing, 13, true);
                networkData.jackpotMinorWinAmount = 0;
            }
        } else if (networkData.jackpotMajorWinAmount !== undefined && networkData.jackpotMajorWinAmount) {
            const amount = parseFloat(networkData.jackpotMajorWinAmount);
            if (!isNaN(amount)) {
                gameAssets.amazingWinValueBitmap.text = amount.toFixed(2);
                setUpAnimation(gameAssets.amazing, 16, true);
                networkData.jackpotMajorWinAmount = 0;
            }
        } else if (networkData.jackpotGrandWinAmount !== undefined && networkData.jackpotGrandWinAmount) {
            const amount = parseFloat(networkData.jackpotGrandWinAmount);
            if (!isNaN(amount)) {
                gameAssets.amazingWinValueBitmap.text = amount.toFixed(2);
                setUpAnimation(gameAssets.amazing, 19, true);
                networkData.jackpotGrandWinAmount = 0;
            }
        }

        if (networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin) {
            delayedCall = gsap.delayedCall(4, () => {
            gameAssets.amazingWinValueBitmap.visible = false
            showJackpots()
            });
            delayedCalls.push(delayedCall);
          } else {
            delayedCall = gsap.delayedCall(4.5, () => {
              clearGame();
            });
      
            delayedCalls.push(delayedCall);
          }
    } else if(networkData.jackpotMinorWin || networkData.jackpotMajorWin || networkData.jackpotGrandWin){
        gameAssets.amazingWinValueBitmap.visible = false;
        showJackpots()
    }  else {
        clearGame();
      }


    // gsap.delayedCall(2, ()=>{
    //     resetGameSettings(1)
    // })


}

const clearGame = () =>{
    gameData.gameState = GAME_STATES.IDLE
    gameAssets.amazing.interactive = false
    delayedCalls.forEach(c => {
        if(c) c.kill()
    })

    stopCoinAnimation()
    if(networkData.lastJackpot == 'grand'){
        setUpAnimation(gameAssets.amazing, 20, false)
    } else if(networkData.lastJackpot == 'major'){
        setUpAnimation(gameAssets.amazing, 17, false)
    } else {
        setUpAnimation(gameAssets.amazing, 14, false)
    }
    playMiniAudio(false)
    playBigAudio(false)
    playMegaAudio(false)
    playUltraAudio(false)
    playEnkCAudio(true)
    gameAssets.dimmer.visible = false;
    resetGameSettings(0.7)
    gameAssets.amazingWinValueBitmap.visible = false;

    
}

const increaseNumCount = (textGameObject, value, duration = 8) => {

    textGameObject.text = 0
    incrementValue(
        textGameObject, 
        value, //winningAmount(),
        duration
    )

}
